import React from "react";
import { CircleDotIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { SectionHeading } from "./SectionHeading";
import { patientFactors } from "../data/content";
export function ProblemSection() {
  return <section className="w-full bg-white px-4 py-16 sm:py-20" data-id="element-257" data-mp="30isffcrxv9rd">
      <div className="mx-auto max-w-3xl" data-id="element-258" data-mp="2vq7p4l88resl">
        <SectionHeading eyebrow="A more structured approach to insulin resistance nutrition care" title="The challenge isn't simply understanding insulin resistance." subtitle="It's knowing what information to organize, what to review, and how to structure the nutrition care process without rebuilding your own resources every time." data-id="element-259" data-mp="2vp6euiz1uwbx" />

        <div className="mt-10 rounded-2xl bg-cream p-5 sm:p-8" data-id="element-260" data-mp="3eia9o7o07f84">
          <p className="font-serif text-xl font-bold text-navy" data-id="element-261" data-mp="1p1snii9i6wxv">Every patient presents a different combination of factors:</p>
          <ul className="mt-5 space-y-3" data-id="element-262" data-mp="1k3zj9urrgd08">
            {patientFactors.map(factor => <li key={factor} className="flex items-start gap-3 text-[16px] font-medium text-ink sm:text-lg" data-id="element-263" data-mp="jdwnp64e030l">
                <CircleDotIcon className="mt-1 h-5 w-5 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-264" data-mp="od9g06e122ak" />
                {factor}
              </li>)}
          </ul>
        </div>

        <div className="mt-10 space-y-5 text-[17px] leading-relaxed text-muted sm:text-lg" data-id="element-265" data-mp="x4rvsg72ag34">
          <p data-id="element-266" data-mp="124ebcwad48f3">
            When all these considerations come together, organizing a comprehensive nutrition consultation can become
            challenging, <strong className="text-ink" data-id="element-267" data-mp="170v1fw14gwut">especially when time is limited.</strong>
          </p>
          <p data-id="element-268" data-mp="1c2kax78p52gs">You may already understand the fundamentals of insulin resistance.</p>
          <p data-id="element-269" data-mp="1g22zcczq7vod">You may know the importance of nutrition, physical activity, lifestyle habits, and individualized care.</p>
          <p data-id="element-270" data-mp="3duyueaqw2ezb">You may already have access to excellent clinical guidelines.</p>
          <p className="border-l-4 border-gold pl-4 font-serif text-xl font-bold leading-snug text-navy sm:text-2xl" data-id="element-271" data-mp="3hviot6k2v4hr">
            But that doesn't necessarily mean you have a practical system for organizing everything you need to review.
          </p>
          <p data-id="element-272" data-mp="y0p20ts4y3g8">
            That's exactly why I created <strong className="text-ink" data-id="element-273" data-mp="y1qcox58onxf">Insulin Resistance Nutrition Blueprint™</strong>.
          </p>
          <p data-id="element-274" data-mp="tyk77rpyb0s0">
            I wanted to bring the major stages of insulin resistance nutrition care into one structured reference system, so
            you can organize your clinical workflow without having to build your own collection of notes, checklists, and
            templates from scratch.
          </p>
          <p data-id="element-275" data-mp="1ho4v8p0yoo85">
            My goal was simple: help you spend less time organizing scattered resources and more time using a clear,
            repeatable structure for your professional work.
          </p>
        </div>

        <div className="mt-10" data-id="element-276" data-mp="1qn9rtpsyq7ho">
          <CTAButton label="I want a clearer approach to insulin resistance care" note="One-Time Payment of $27 USD · Instant Digital Access · 7-Day Money-Back Guarantee" data-id="element-277" data-mp="1lr1gknhvyyfs" />
        </div>
      </div>
    </section>;
}